import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import NoticeRecordBlock from './components/NoticeRecordBlock';

const { Cell } = ResponsiveGrid;

const NoticeRecord = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="紀錄列表"
        breadcrumbs={[
          {
            name: '通知紀錄',
          },
          {
            name: '紀錄列表',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <NoticeRecordBlock />
    </Cell>
  </ResponsiveGrid>
);

export default NoticeRecord;
